"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiOpciFrequenceTransactionTrads = void 0;
exports.ESubScpiOpciFrequenceTransactionTrads = {
    annuelle: "Annuelle",
    annuelle_supereur: "> 1 an",
    mensuelle: "Mensuelle",
    trimestrielle: "Trimestrielle",
};
